import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../lib/auth';

export function Header() {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/login', { replace: true });
  };

  return (
    <header className="border-b border-slate-200 bg-white no-print">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-3">
        <Link to="/" className="flex items-center gap-2">
          <span className="rounded bg-brand px-2 py-1 text-xs font-bold text-white">
            Structive
          </span>
          <span className="text-base font-semibold text-slate-800">
            採用力診断ツール
          </span>
        </Link>
        <div className="flex items-center gap-2">
          <Link
            to="/ad-generate"
            className="btn-secondary"
            title="会社情報 or 既存原稿から媒体別の項目原稿を生成する"
          >
            求人原稿生成
          </Link>
          <Link
            to="/ad-review"
            className="btn-secondary"
            title="求人原稿をAIで添削する"
          >
            求人原稿添削
          </Link>
          <Link
            to="/settings/roadmap-templates"
            className="btn-secondary"
            title="ロードマップテンプレートの編集"
          >
            設定
          </Link>
          <button onClick={handleLogout} className="btn-secondary">
            ログアウト
          </button>
        </div>
      </div>
    </header>
  );
}
